import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {AuthenticatedGuard} from '../shared/guards/authenticated.guard';

import {HomeComponent} from './home.component';

@NgModule({
  imports: [RouterModule.forChild(
      [{path: '', component: HomeComponent, canActivate: [AuthenticatedGuard]}])],
  exports: [RouterModule]
})
export class HomeRoutingModule {
}
